<template>
  <div>
    <BaseDataIterator :service="fetchData" disable-search disable-filters>
      <template #custom-actions="dataIteratorProps">
        <AddSubscriptionOrderAction
          :account-subscription-id="accountSubscription.uuid"
          @success="dataIteratorProps.queryContext.actions.execute"
        />
      </template>
      <!-- props
        data, fetchList
      -->
      <template #default="dataIteratorProps">
        <ul class="divide-y divide-gray-200">
          <li v-for="item in dataIteratorProps.data" :key="item.period">
            <SubscriptionOrderListItem
              v-bind="item"
              v-model="currentPeriod"
              :account-subscription="accountSubscription"
              @change="dataIteratorProps.fetchList"
            />
          </li>
        </ul>
      </template>
    </BaseDataIterator>
  </div>
</template>

<script>
import { accountSubscriptionSubscriptionOrdersClient } from '@/api/clients';
import { groupBy, map } from 'lodash-es';
import SubscriptionOrderListItem from './SubscriptionOrderListItem.vue';
import AddSubscriptionOrderAction from './AddSubscriptionOrderAction.vue';

export default {
  components: {
    SubscriptionOrderListItem,
    AddSubscriptionOrderAction,
  },
  props: {
    accountSubscription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentPeriod: null,
    };
  },
  methods: {
    fetchData() {
      return accountSubscriptionSubscriptionOrdersClient
        .list(this.accountSubscription.uuid)
        .then((response) => {
          const data = map(groupBy(response.data.data, 'period'), (subscriptionOrders, period) => ({
            period: Number.parseInt(period, 10),
            subscriptionOrders,
          }));

          return Promise.resolve({ data });
        });
    },
  },
};
</script>
